<template>
    <v-bottom-navigation
        background-color="primary"
        dark
        fixed
        app
        class="d-md-none d-flex"
    >
        <!-- Con el v-if evitamos añadir el icono de Agenda Urbana-->
        <v-btn
            v-for="(enlace, index) in enlacesMovil"
            v-if="index != 1"
            :key="enlace.texto"
            :to="enlace.link"
            :exact="index != 2"
        >
            <v-icon v-if="index != 3"> {{ enlace.icono }} </v-icon>
            <ModalBusqueda v-else>
                <v-icon> {{ enlacesMovil[3].icono }} </v-icon>
            </ModalBusqueda>
        </v-btn>
    </v-bottom-navigation>
</template>

<script>
import ModalBusqueda from "../components/ModalBusqueda.vue";

export default {
    name: "FooterMovil",
    props: {
        enlacesMovil: {
            type: Array,
            default: [],
        },
    },
    components: { ModalBusqueda },
};
</script>
